require('../../modules/es6.number.is-nan');
module.exports = require('../../modules/_core').Number.isNaN;



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/fn/number/is-nan.js
// module id = y/8q
// module chunks = 0